import _get from 'lodash/get';
import { setCurrentChatroom, expandWidget } from './index';
import wix from '../services/wix';
import { AVATARS } from '../constants/avatars';
import socialServerApi from '../services/socialServerApi';

export const startPrivateChat = ({
  userId,
  requestId,
}: {
  userId: string;
  requestId: string;
}) => {
  return async function (dispatch, getState) {
    const responseEventName = `ChatWidget.startPrivateChatResponse.${requestId}`;
    try {
      const {
        chatroomId,
        chatroom,
      } = await socialServerApi.createPrivateChatRoom(userId);
      const imgUrl = _get(chatroom, 'displayData.image.url');
      const name = _get(chatroom, 'displayData.name');
      const avatar = imgUrl
        ? { ...AVATARS.IMG.prop, imgUrl }
        : AVATARS.NONE.prop;

      dispatch(setCurrentChatroom({ id: chatroomId, name, avatar }));

      if (getState().deviceType === 'mobile') {
        wix.showMobileComponent();
      } else {
        dispatch(expandWidget());
      }

      wix.publishToPubSub(responseEventName, { success: true });
    } catch (e) {
      wix.publishToPubSub(responseEventName, { success: false });
    }
  };
};
